document.addEventListener('DOMContentLoaded', () => {
  const video = document.querySelector('.hero-video');
  if (!video) return;

  // Garantisce che sia silenziato prima del play (autoplay consentito se muto)
  video.muted = true;

  const tryPlay = () => {
    const p = video.play();
    if (p !== undefined) {
      p.catch(() => {
        // Autoplay bloccato: avvia al primo gesto dell’utente
        const onInteract = () => {
          video.play().catch(() => {}); // opzionale: gestisci errori
          window.removeEventListener('click', onInteract);
          window.removeEventListener('touchstart', onInteract);
        };
        window.addEventListener('click', onInteract, { once: true });
        window.addEventListener('touchstart', onInteract, { once: true, passive: true });
      });
    }
  };

  if (document.readyState === 'complete') tryPlay();
  else window.addEventListener('load', tryPlay);
});
